'use strict';
var $export = require('./_export')
  , $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */){
    return $filter(this, callbackfn, arguments[1]);
  }
});


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/core-js/modules/es6.array.filter.js
// module id = ../../../../core-js/modules/es6.array.filter.js
// module chunks = 3